import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => {
  return createStyles({
    tagInfoElement: {
      margin: theme.spacing(0.5, 0)
    },
    row: {
      display: 'flex',
      marginTop: theme.spacing(2)
    }
  });
});